export default {
    post: function (url, data) {
        return new Promise(function (resolve, reject) {

            //Email required
            if (data.email == null || data.email === '') {
                reject({
                    status: 400,
                    body:
                        [
                            {
                                property: 'Email',
                                message: 'MESSAGE__ACCOUNT__EMAIL_REQUIRED'
                            }
                        ]
                });
                return;
            } else {
                //Email is not valid
                const re = /\S+@\S+\.\S+/;
                if (!re.test(data.email)) {
                    reject({
                        status: 400,
                        body:
                        [
                            {
                                property: 'Email',
                                message: 'MESSAGE__ACCOUNT__EMAIL_NOT_VALID'
                            }
                        ]
                    });
                    return;
                }
            }

            //Password required
            if (data.password == null || data.password === '') {
                reject({
                    status: 400,
                    body:
                        [
                            {
                                property: 'Password',
                                message: 'MESSAGE__ACCOUNT__PASSWORD_REQUIRED'
                            }
                        ]
                });
                return;
            }

            //Invalid credentials
            if (data.email !== 'john@example.com' || data.password !== 'password') {
                reject({
                    status: 400,
                    body:
                        [
                            {
                                property: 'Email',
                                message: 'MESSAGE__ACCOUNT__EMAIL_OR_PASSWORD_INVALID'
                            }
                        ]
                });
                return;
            }

            //Ok
            resolve({
                body: {
                    email: 'john@test.com',
                    token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c'
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./test/data/account/signin.js